{
  "column": {
    "name": "Nom",
    "type": "Type",
    "subscribedServices": "Services souscrits",
    "expirationDate": "Date d'expiration",
    "expirationDateFormat": "DD/MM/YYYY à HH:mm"
  },
  "addSingleCertificate": "Ajout d'un certificat",
  "addCertificate": "Ajouter un certificat",
  "updateCertificate": "Mettre à jour le certificat",
  "certificate": {
    "typeTitle": "Type de certificat",
    "deviceTrustchain": "Device Trustchain",
    "pkiRootCa": "MS PKI root CA",
    "ldapsRootCa": "LDAPS root CA"
  },
  "caRestrictionInformation": "Le certificat déposé doit être un fichier .PEM et doit peser moins de 1Mo.",
  "dropCertificate": "Déposer le certificat ici ou cliquez ici pour lancer la sélection",
  "noCertificate": "Aucun certificat n'est inscrit dans le cadre du truststore",
  "validation": {
    "rootCa": "Le certificat est obligatoire et doit être au format .PEM",
    "certType": "Le type de certificat est obligatoire"
  }
}
